import styled from 'styled-components/macro';

const FieldInfo = styled.p`
  padding: ${props => `${props.theme.spacing.xs2} 0`};
  font-size: ${props => props.theme.sizes.xs};
  width: 100%;
  color: ${props => props.theme.colors.grey};
  line-height: ${props => props.theme.spacing.m};
`;

export default FieldInfo;
